import { useRef, useState } from 'react';

/**
 * provides all element needed by a Menu implementation, it returns a tuple of
 * 4 elements: `[state, anchorRef, openMenu, closeMenu, toggleState]`:
 *
 * `state`: boolean value that represents if the menu is open or closed
 *
 * `anchorRef`: a ref that should passed to the `ref` property of the  anchor element of the menu
 *
 * `openMenu`: callback that sets the state to true, can be used as `onOpen` handler
 *
 * `closeMenu`: callback that sets the state to false, can be used as `onClose` handler
 *
 * `toggleState`: callback that toggles the value of state
 * @param {Boolean} initialStateValue
 * @param {*} initialRefValue
 * @returns Array
 */
export const useMenu = (initialStateValue, initialRefValue) => {
  const anchorRef = useRef(initialRefValue);
  const [state, setState] = useState(Boolean(initialStateValue));

  const openMenu = () => setState(true);
  const closeMenu = () => setState(false);
  const toggleState = () => setState((oldState) => setState(!!oldState));

  return [state, anchorRef, openMenu, closeMenu, toggleState];
};

export default useMenu;
